import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Dotdotdot from 'react-dotdotdot';
import classNames from 'classnames';
import ReadMore from 'components/ReadMore';

const Subtitle = props => {
  const {
    isDisabled,
    isRedirect,
    link,
    onSubtitleClick,
    subtitle,
    subtitleLines,
    target,
    theme,
    truncateSubtitle,
  } = props;
  let subtitleLink = link;
  const subTitleClasses = [theme.subtitle];
  if (!subtitle || subtitle.length === 0) return null;
  let subtitleText;
  if (truncateSubtitle) {
    subtitleText = (
      <ReadMore moreText="More" lessText="Less" lines={subtitleLines || 2} theme={theme}>
        {subtitle}
      </ReadMore>
    );
  } else {
    subtitleText = subtitleLines ? (
      <Dotdotdot clamp={subtitleLines}>{subtitle}</Dotdotdot>
    ) : (
      subtitle
    );
  }
  if (!link || truncateSubtitle || isDisabled) {
    return <div className={classNames([theme.subtitle, theme.disabled])}>{subtitleText}</div>;
  }
  if (isRedirect) {
    subtitleLink = null;
    subTitleClasses.push(theme.redirectLink);
  }
  const onClick = () => {
    if (onSubtitleClick) {
      onSubtitleClick();
    }
  };

  function linkHander(e) {
    onClick(e);
  }

  return (
    <Link
      to={subtitleLink}
      target={target}
      onClick={linkHander}
      className={classNames(subTitleClasses)}
      aria-live="off"
      aria-hidden="true"
    >
      {subtitleText}
    </Link>
  );
};

Subtitle.defaultProps = {
  isDisabled: false,
  isRedirect: false,
  link: null,
  onSubtitleClick: () => {},
  subtitle: null,
  subtitleLines: null,
  target: null,
  theme: {},
  truncateSubtitle: null,
};

Subtitle.propTypes = {
  isDisabled: PropTypes.bool,
  isRedirect: PropTypes.bool,
  link: PropTypes.string,
  onSubtitleClick: PropTypes.func,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitleLines: PropTypes.number,
  target: PropTypes.string,
  theme: PropTypes.shape({}),
  truncateSubtitle: PropTypes.bool,
};

export default Subtitle;
